import onDOMContentLoaded from '../../base/util/dom/onDOMContentLoaded';

class Accessibility {
    public static readonly Selectors = {
        contrastBtn: '[data-toggle="highContrast"]'
    };

    public static readonly Attributes = {
        toggleState: 'data-toggle-state'
    };

    public static readonly LocalStorageItems = {
        contrast: 'firb:contrast'
    };

    public static readonly ToggleStates = {
        active: 'on',
        inactive: 'off'
    };

    public static readonly ClassesCss = {
        highContrast: 'high-contrast-mode'
    };
    private readonly contrastBtnCollection: HTMLElement[]

    constructor(elements: HTMLElement[]) {
        this.contrastBtnCollection = elements
    }

    public init(): void {
        if(this.contrastBtnCollection?.length < 1) {
            return
        }

        this.init_storage()
        this.addEvents()
        console.info('Accessibility module initialized')
    }

    private addEvents(): void {
        if (this.contrastBtnCollection) {
            this.contrastBtnCollection.forEach( element => {
                element.addEventListener('click', this.toggle_handler.bind(this), true)
            })
        }
    }

    private toggle_handler(ev : Event): void {
        ev.preventDefault()
        const elementTarget: HTMLElement = ev.currentTarget as HTMLElement
        if(elementTarget && elementTarget.hasAttribute(Accessibility.Attributes.toggleState)) {
            const newState = elementTarget.getAttribute(Accessibility.Attributes.toggleState) === Accessibility.ToggleStates.inactive
                ? Accessibility.ToggleStates.active
                : Accessibility.ToggleStates.inactive

                this.update_high_contrast_mode(newState)
        }
    }

    private init_storage(): void {
        Object.entries(Accessibility.LocalStorageItems).forEach(([key, storageKey]) => {
            if (localStorage.getItem(storageKey) === null) {
                localStorage.setItem(storageKey, Accessibility.ToggleStates.inactive)
            }
        })

        const storedState = localStorage.getItem(Accessibility.LocalStorageItems.contrast)
        const currentState = storedState === Accessibility.ToggleStates.active
            ? Accessibility.ToggleStates.active
            : Accessibility.ToggleStates.inactive

        this.update_high_contrast_mode(currentState)

        this.contrastBtnCollection?.forEach(element => {
            this.update_toggle_accessible_text(element, currentState)
        });
    }

    private update_storage(item: string, newState: string): void {
        localStorage.setItem(item, newState)
    }

    private update_toggle_accessible_text(item: HTMLElement, newState: string): void {
        const dataAttribute = `[data-text-${newState}]`
        const textNode = item.querySelector(dataAttribute) as HTMLElement
        if(textNode) {
            item.setAttribute('aria-label', textNode?.textContent || '')
        }
    }

    private update_high_contrast_mode(state: string): void {
        if(!state) {
            return
        }

        if(state === Accessibility.ToggleStates.active) {
            document.body.classList.add(Accessibility.ClassesCss.highContrast)
        } else {
            document.body.classList.remove(Accessibility.ClassesCss.highContrast)
        }

        this.contrastBtnCollection?.forEach(element => {
            const button = element as HTMLElement
            button.setAttribute(Accessibility.Attributes.toggleState, state)
            this.update_toggle_accessible_text(button, state)
        });
        this.update_storage(Accessibility.LocalStorageItems.contrast, state)
    }
}

onDOMContentLoaded(()=> {
    const accessibilityDomElements = Array.prototype.slice.call(document.querySelectorAll(Accessibility.Selectors.contrastBtn)) as HTMLElement[]
    if(accessibilityDomElements.length > 0) {
        const accessibility: Accessibility  = new Accessibility(accessibilityDomElements)
        accessibility.init()
    }
})